import { defineStore } from "pinia";
import { fetchSearchData } from "~/composables/services/search";
import type { SearchInput, ContentType, Tag, Topic } from "@/types";

export const useSearchStore = defineStore("search", {
  persist: false,
  state: (): SearchInput => ({
    searchText: "",
    searchContentTypes: [],
    searchTags: [],
    searchTopics: [],
    searchResults: null,
    status: "idle"
  }),

  getters: {
    getSearchText: state => state.searchText,
    getResults: state => state.searchResults,
    getStatus: state => state.status
  },

  actions: {
    searchRequest(text: string) {
      this.status = "loading";
      this.searchText = text;
      this.searchResults = null;
    },

    searchSuccess(results: any) {
      this.status = "success";
      this.searchResults = results;
    },

    searchFailure() {
      this.status = "error";
      this.searchResults = null;
    },

    setSearchText(text: string) {
      this.searchText = text;
    },

    setSearchContentTypes(contentTypes: ContentType[]) {
      this.searchContentTypes = contentTypes;
    },

    setSearchTags(tags: Tag[]) {
      this.searchTags = tags;
    },

    setSearchTopics(topics: Topic[]) {
      this.searchTopics = topics;
    },

    async runSearch() {
      try {
        const results = await fetchSearchData({
          searchText: this.searchText,
          searchContentTypes: this.searchContentTypes,
          searchTags: this.searchTags,
          searchTopics: this.searchTopics
        });

        if (results) {
          this.searchSuccess(results);
        } else {
          throw new Error("Invalid search response");
        }
      } catch (err) {
        this.searchFailure();
      }
    }
  }
});
